import { PROTOCOL } from "@/base/base.constants";

const AGATHA_HOST = process.env.NEXT_PUBLIC_AGATHA_HOST;
export const AGATHA_ORIGIN = `${PROTOCOL}://${AGATHA_HOST}`;

export const SEARCH_ROUTE = "/search";

export const SEARCH_PAGE_SEARCH_FORM_ID = "search-form-id";

export const MAX_NUMBER_OF_RECENT_SEARCHES = 3;

export const TIME_DELAY_TO_FETCH_SUGGESTIONS = 300;

export const CLASSNAME_FOR_AGATHA_GENERATED_SUGGESTION =
  "agatha-generated-suggestion";

export const FIRST_PAGE_INDEX = 0;
export const NUMBER_OF_CARDS_TO_FETCH_PER_PAGE = 24;

export const MIN_GRADE_RANGE = 60;
export const MAX_GRADE_RANGE = 1260;

export const GRADE_MARKS = [
  { value: 60, label: "K" },
  { value: 120 },
  { value: 180 },
  { value: 240 },
  { value: 300 },
  { value: 360 },
  { value: 420 },
  { value: 480 },
  { value: 540 },
  { value: 600 },
  { value: 660 },
  { value: 720 },
  { value: 780 },
  { value: 840 },
  { value: 900 },
  { value: 960 },
  { value: 1020 },
  { value: 1080 },
  { value: 1140 },
  { value: 1200 },
  { value: 1260, label: "12" },
];

export const GRADE_MARK_STEP = 60;

export const LEXILE_GRADE_MAP = {
  60: {
    grade: "K",
    lexile: 60,
  },
  120: {
    grade: 1,
    lexile: 120,
  },
  180: {
    grade: 1,
    lexile: 180,
  },
  240: {
    grade: 1,
    lexile: 240,
  },
  300: {
    grade: 2,
    lexile: 300,
  },
  360: {
    grade: 2,
    lexile: 360,
  },
  420: {
    grade: 2,
    lexile: 420,
  },
  480: {
    grade: 2,
    lexile: 480,
  },
  540: {
    grade: 3,
    lexile: 540,
  },
  600: {
    grade: 3,
    lexile: 600,
  },
  660: {
    grade: 4,
    lexile: 660,
  },
  720: {
    grade: 4,
    lexile: 720,
  },
  780: {
    grade: 5,
    lexile: 780,
  },
  840: {
    grade: 5,
    lexile: 840,
  },
  900: {
    grade: 5,
    lexile: 900,
  },
  960: {
    grade: 6,
    lexile: 960,
  },
  1020: {
    grade: 7,
    lexile: 1020,
  },
  1080: {
    grade: 7,
    lexile: 1080,
  },
  1140: {
    grade: 8,
    lexile: 1140,
  },
  1200: {
    grade: "9-10",
    lexile: 1200,
  },
  1260: {
    grade: "11-12",
    lexile: 1260,
  },
};

export const DEFAULT_LEXILE_LEVEL_RANGE = "60-1260";

export const ALL_CONTENT_TYPES_SELECTION_VALUE = "all";

export const SEARCH_STRATEGIES = {
  RECOMMENDATIONS: "recommendations",
  STATIC_RESULTS: "retrieve_static_results",
  SIMILAR_TO: "SIMILAR_TO",
};

export const SUGGESTION_CATEGORIES = {
  ESSENTAL_QUESTION: "eq",
};

export const SUGGESTION_CATEGORY_LABELS = {
  [SUGGESTION_CATEGORIES.ESSENTAL_QUESTION]: "Essential question",
};

// these match oulipo block types
export const BLOCK_TYPES = {
  PAGE: "page",
  SEARCH_RESULT_LIST: "search_result_list",
};

export const FILTERS = {
  language: "Language",
  contentTypes: "Content Types",
  readingLevel: "Reading Level",
  readingSkills: "Reading Skills",
};

export const URL_PARAMS = {
  page: "page",
  needle: "needle",
  sortBy: "sort_by",
  gradeGroups: "grade_groups",
  contentTypes: "content_types",
  staticResultsId: "static_results_id",
  adminContentSettings: "admin_content_settings",
  taxonomySlug: "taxonomy_slug",
};

export const SEARCH_PARAMS = {
  video: "video",
  language: "language",
  audioTrack: "audiotrack",
  articleHeader: "articleheader",
  readingSkills: "reading_skills",
  lexileLevelRange: "lexile_level_range",
  interactiveVideoLink: "interactivevideolink",
  instructionalFeatures: "instructional_features",
};
